import React, { useState } from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Filters from './Filters'
import * as Page1 from "./analisiProposte/Page";
import * as Page2 from "./analisiAccettate/Page";
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { Button } from "src/mtska-frontend-app-component";

const Container = ({ dataProviderName, filters }) => {
    const { t } = useTranslation();
    const [reportVisible, setReportVisible] = useState(true);
    const showFilters = true;
    const showKPI = true;

    const report = [
        {
            title: t('Proposte'),
            icon: 'faHandshake',
            pages: [
                {
                    title: t('Proposte'),
                    icon: 'faCalendar',
                    component: <Page1.default dataProviderName={dataProviderName} filters={filters} key={1} />
                },
                {
                    title: t('Accettate'),
                    icon: 'faCalendar',
                    component: <Page2.default dataProviderName={dataProviderName} filters={filters} key={1} />
                }
            ]
        }
    ];

    return (
        <Box>
            {(showKPI || showFilters) &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Proposal status')}</h2>
                </Box>
            }

            {showFilters &&
                <Filters dataProviderName={dataProviderName} filters={filters} />
            }

            <Box className="dashboard-report-visibility-wrapper">
                <Button className="dashboard-report-visibility-toggler" onClick={() => setReportVisible(!reportVisible)} variant={'outlined'}>{reportVisible ? t('Hide report') : t('Show report')}</Button>
            </Box>

            {
                reportVisible && <ComponentSlider report={report} />
            }
        </Box>
    )
}

export default Container;